import React, { useId, useMemo } from 'react'
import { useIntl } from 'react-intl'
import SearchFloatingPanel, { SearchFloatingPanelProps } from './SearchFloatingPanel'
import TourV2SearchGroupItems from 'components/Search/TourV2/TourV2SearchGroupItems'
import { getTourGroupTypesList } from 'components/Search/TourV2/TourV2SearchGroupSelect'

interface Props extends Omit<
  SearchFloatingPanelProps,
  'title' | 'isConfirmButtonHidden' | 'children'
> {
  onClose: () => void
}

function TourGroupTypePanel(props: Props) {
  const { onClose } = props
  const intl = useIntl()
  const formId = useId()

  const tourGroupTypesList = useMemo(() => getTourGroupTypesList(intl), [intl])

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onClose()
  }

  return (
    <SearchFloatingPanel
      {...props}
      title="What type of journey?"
      confirmText="Apply"
    >
      <form onSubmit={onSubmit} id={formId}>
        <TourV2SearchGroupItems groupTypes={tourGroupTypesList} />
      </form>
    </SearchFloatingPanel>
  )
}

export default TourGroupTypePanel
